<template>
  <div class="rtl has-text-right columns is-align-items-center is-multiline" :class="classContainer">
    <p class="column bold" :class="[horizantal ? 'is-12' : 'is-5', classTitle]">{{ title }}:</p>
    <div @click="showAttributeEditor" class="btn column cursor_pointer" :class="[horizantal ? 'is-12' : 'is-3', classValue]">
      <div v-if="value" class="blue_text">
        <p>{{ displayValue || value }}</p>
      </div>
      <div v-else>
        <img src="/edit_icon.svg" width="24px" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'attribute-display',
  props: {
    value: {
      type: String
    },
    displayValue: {
      type: String
    },
    title: {
      type: String
    },
    data: {
      type: Object,
      require: true
    },
    type: {
      type: String
    },
    horizantal: {
      type: Boolean
    },
    componentName: {
      type: String,
      default: 'AttributeUpsertModal'
    },
    options: {
      type: Array,
      default: () => { return [] }
    },
    requestName: {
      type: String
    },
    requestValue: {
      type: String
    },
    classTitle: {
      type: String
    },
    classValue: {
      type: String
    },
    classContainer: {
      type: String
    },
    beforeAction: {
      type: Function,
      default: () => {}
    },
    afterAction: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    ...mapMutations('modals', ['create']),
    showAttributeEditor () {
      this.create({
        designator: 'questions-form',
        component_name: this.componentName,
        modal_title: this.title,
        data: this.data,
        textValue: this.value,
        request: this.requestName,
        value: this.requestValue,
        type: this.type,
        options: this.options,
        beforeAction: this.beforeAction,
        afterAction: this.afterAction
      })
    }
  }
}
</script>
